var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_circle_outline",
    clipPath: "url(#clip0_5784_12650)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.875 16.625H26.125V26.125H16.625V30.875H26.125V40.375H30.875V30.875H40.375V26.125H30.875V16.625ZM28.5 4.75C15.39 4.75 4.75 15.39 4.75 28.5C4.75 41.61 15.39 52.25 28.5 52.25C41.61 52.25 52.25 41.61 52.25 28.5C52.25 15.39 41.61 4.75 28.5 4.75ZM28.5 47.5C18.0263 47.5 9.5 38.9738 9.5 28.5C9.5 18.0263 18.0263 9.5 28.5 9.5C38.9738 9.5 47.5 18.0263 47.5 28.5C47.5 38.9738 38.9738 47.5 28.5 47.5Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5784_12650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTicketIcon);
export default __webpack_public_path__ + "static/media/create-ticket-icon.ca7c2b326b872194239132956452388e.svg";
export { ForwardRef as ReactComponent };